import { Injectable } from '@angular/core';
import { SessionService } from '@bayclubs/utils';

@Injectable({
    providedIn: 'root'
})
export class FiltersStorageService {
    constructor(private sessionService: SessionService) {}

    private calendarUrlSessionStorageKey = 'calendarUrl';
    private listUrlSessionStorageKey = 'listUrl';
    private instructorsUrlSessionStorageKey = 'instructorsUrl';
    private subBoardUrlSessionStorageKey = 'subBoardUrl';
    private payrollReportUrlSessionStorageKey = 'payrollReportUrl';
    private clubCentricReportUrlSessionStorageKey = 'clubCentricReportUrl';
    private attendanceReportUrlSessionStorageKey = 'attendanceReportUrl';
    private instructorCentricReportUrlSessionStorageKey = 'instructorCentricReportUrl';
    private reportsUrlSessionStorageKey = 'reportsUrl';

    get calendarUrl(): string {
        const urlItem = this.sessionService.getItem(this.calendarUrlSessionStorageKey, { url: null });
        return urlItem.url;
    }

    set calendarUrl(newUrl: string) {
        const newUrlItem = { url: newUrl };
        this.sessionService.setItem(this.calendarUrlSessionStorageKey, newUrlItem);
    }

    get listUrl(): string {
        const urlItem = this.sessionService.getItem(this.listUrlSessionStorageKey, {
            url: null
        });
        return urlItem.url;
    }

    set listUrl(newUrl: string) {
        const newUrlItem = { url: newUrl };
        this.sessionService.setItem(this.listUrlSessionStorageKey, newUrlItem);
    }

    get instructorsUrl(): string {
        const urlItem = this.sessionService.getItem(this.instructorsUrlSessionStorageKey, { url: null });
        return urlItem.url;
    }

    set instructorsUrl(newUrl: string) {
        const newUrlItem = { url: newUrl };
        this.sessionService.setItem(this.instructorsUrlSessionStorageKey, newUrlItem);
    }

    get subBoardUrl(): string {
        const urlItem = this.sessionService.getItem(this.subBoardUrlSessionStorageKey, { url: null });
        return urlItem.url;
    }

    set subBoardUrl(newUrl: string) {
        const newUrlItem = { url: newUrl };
        this.sessionService.setItem(this.subBoardUrlSessionStorageKey, newUrlItem);
    }

    get payrollReportUrl(): string {
        const urlItem = this.sessionService.getItem(this.payrollReportUrlSessionStorageKey, { url: null });
        return urlItem.url;
    }

    set payrollReportUrl(newUrl: string) {
        const newUrlItem = { url: newUrl };
        this.sessionService.setItem(this.payrollReportUrlSessionStorageKey, newUrlItem);
    }

    get instructorCentricReportUrl(): string {
        const urlItem = this.sessionService.getItem(this.instructorCentricReportUrlSessionStorageKey, { url: null });
        return urlItem.url;
    }

    set instructorCentricReportUrl(newUrl: string) {
        const newUrlItem = { url: newUrl };
        this.sessionService.setItem(this.instructorCentricReportUrlSessionStorageKey, newUrlItem);
    }

    get attendanceReportUrl(): string {
        const urlItem = this.sessionService.getItem(this.attendanceReportUrlSessionStorageKey, { url: null });
        return urlItem.url;
    }

    set attendanceReportUrl(newUrl: string) {
        const newUrlItem = { url: newUrl };
        this.sessionService.setItem(this.attendanceReportUrlSessionStorageKey, newUrlItem);
    }

    get clubCentricReportUrl(): string {
        const urlItem = this.sessionService.getItem(this.clubCentricReportUrlSessionStorageKey, { url: null });
        return urlItem.url;
    }

    set clubCentricReportUrl(newUrl: string) {
        const newUrlItem = { url: newUrl };
        this.sessionService.setItem(this.clubCentricReportUrlSessionStorageKey, newUrlItem);
    }

    get reportsUrl(): string {
        const urlItem = this.sessionService.getItem(this.reportsUrlSessionStorageKey, { url: null });
        return urlItem.url;
    }

    set reportsUrl(newUrl: string) {
        const newUrlItem = { url: newUrl };
        this.sessionService.setItem(this.reportsUrlSessionStorageKey, newUrlItem);
    }


}
